import axios from '@/axios';

/**
 * 테스트 환경(intest/stg) 메시지 발송 화이트리스트 API
 * - 전역 공통 단일 목록이며 inapi 가 소유한다.
 * - crm-api 가 발송 직전에 이 목록을 조회해 알림톡/브랜드메시지/SMS 를 차단한다.
 */
const SendWhitelistApi = {
  /**
   * 화이트리스트 조회
   * @returns {Promise} { phones: string[] }
   */
  get() {
    return axios.get('/send-whitelist');
  },

  /**
   * 화이트리스트 전체 교체 (부분 수정 API 없음)
   * @param {string[]} phones - 발송 허용 번호 목록
   * @returns {Promise} { phones: string[] }
   */
  replace(phones) {
    return axios.put('/send-whitelist', { phones });
  },
};

export default SendWhitelistApi;
